var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    transform: "translate(-160 -56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 96,
    height: 96,
    rx: 48,
    transform: "translate(160 56)",
    fill: "#f0edf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hotel-2",
    "data-name": "hotel",
    transform: "translate(184 83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10273",
    "data-name": "Path 10273",
    d: "M13.655,24.2a6.4,6.4,0,1,0-6.327-6.4A6.355,6.355,0,0,0,13.655,24.2Zm0-8.533A2.133,2.133,0,1,1,11.545,17.8,2.128,2.128,0,0,1,13.655,15.667Zm25.309-6.4H22.091V26.333H5.218V5H1V37H5.218V30.6H43.182V37H47.4V17.8A8.483,8.483,0,0,0,38.964,9.267Zm4.218,17.067H26.309v-12.8H38.964A4.255,4.255,0,0,1,43.182,17.8Z",
    fill: "#6a55a0",
    stroke: "#f0edf5",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.03b7deef5e890e11d9cb58612e44c439.svg";
export { ForwardRef as ReactComponent };